<template>
  <div
    class="
      list-group-item
      mr-5
      bg-gray-200
      p-4
      rounded-lg
      max-w-xs
      w-96
      relative
    "
  >
    <spinner :loading="deleteSegmentLoader" />
    <!-- invite popup -->
    <InviteMemberModal
      :courseId="segment.courseInfo && segment.courseInfo.courseId"
      :openModal="invitePopup"
      :closeModal="() => invitecancel()"
      :isPipelineUser="true"
    />
    <edit-course-modal
      v-if="editModal"
      :courseId="segment.courseInfo.courseId"
      :openModal="editModal"
      :closePopup="() => (editModal = false)"
      :getDetailsAgain="() => this.$store.dispatch('getPipelineDetails')"
    />
    <section class="flex justify-between">
      <h3 class="flex mb-0">
        <div
          v-if="segment.courseInfo && segment.courseInfo.description"
          class="flex items-center -mt-2 mr-2 relative"
          @mouseenter="() => (showDescription = true)"
          @mouseleave="() => (showDescription = false)"
        >
          <description />

          <!-- discription div  -->
          <div
            :class="[
              'absolute top-0 rounded-md shadow-md z-40 bg-gray-400 p-3 w-40 whitespace-pre-wrap',
              showDescription ? 'flex' : ' hidden',
            ]"
            v-html="segment.courseInfo.description"
            style="right: -170px"
          ></div>
        </div>
        <div v-if="isReminderDone"><clock /></div>
        {{
          segment.courseInfo.courseTitle
            .toLowerCase()
            .startsWith(
              JSON.parse(currentPipelineDetails).pipeline_name.toLowerCase(),
            )
            ? `${segment.courseInfo.courseTitle
                .toLowerCase()
                .replace(
                  JSON.parse(
                    currentPipelineDetails,
                  ).pipeline_name.toLowerCase(),
                  '&hellip;',
                )}`
            : segment.courseInfo.courseTitle
        }}
      </h3>
      <div class="cursor-pointer dropdown dropdown-left">
        <div tabindex="0" class="">
          <threeDots />
        </div>

        <ul
          tabindex="0"
          class="
            p-2
            shadow
            menu
            dropdown-content
            bg-base-100
            rounded-box
            w-40
            z-20
          "
        >
          <li
            @click="
              $router.push(
                `/admin/engage?courseId=${segment.courseInfo.courseId}`,
              ),
               $store.commit('setActiveTab', '/admin/engage')
            "
          >
            <a>Connect</a>
          </li>
          <li @click="() => (editModal = true)">
            <a>Edit</a>
          </li>
          <li @click="() => handleRemoveSegment(segment.courseInfo.courseId)">
            <a>Remove</a>
          </li>
        </ul>
      </div>
    </section>
    <draggable
      class="list-group"
      :list="segment.userInfos"
      :group="{
        name: 'people',
        put: segmentMemberLimit > segment.userInfos.length ? true : false,
      }"
      @change="log"
    >
      <!-- <div v-if="!segment.courseInfo.userinfos.userName" class="py-1 w-full"></div> -->
      <div
        class="list-group-item"
        v-for="(element, index) in segment.userInfos"
        :key="element.userName + index"
      >
        <MemberProfileCard
          :memberData="element"
          :courseId="segment.courseInfo.courseId"
        />
      </div>
    </draggable>
    <button
      :class="[
        'flex',
        segmentMemberLimit > segment.userInfos.length &&
        pipelineStudentsCount < pipelineMemberLimit
          ? 'border-gray-500'
          : 'tooltip tooltip-top cursor-default outline-none border-gray-300',
      ]"
      data-tip="Maximum member limit reached"
      class="
        w-full
        text-center
        flex
        justify-center
        items-center
        rounded-lg
        bg-white
        py-8
        mt-5
        border-2
      "
      @click="
        () =>
          segmentMemberLimit > segment.userInfos.length &&
          pipelineStudentsCount < pipelineMemberLimit
            ? (invitePopup = true)
            : ''
      "
    >
      <font-awesome-icon
        :class="[
          'flex',
          segmentMemberLimit > segment.userInfos.length &&
          pipelineStudentsCount < pipelineMemberLimit
            ? 'text-gray-600'
            : 'tooltip tooltip-top cursor-default outline-none text-gray-300',
        ]"
        size="lg"
        :icon="['fas', 'plus']"
      />
    </button>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import MemberProfileCard from './MemberProfileCard.vue';
import description from '@/components/icons/description.vue';
import spinner from '@/components/spinner.vue';
import InviteMemberModal from '../Audience/InviteMemberModal.vue';
import threeDots from '../icons/threeDots.vue';
import EditCourseModal from '../Courses/EditCourseModal.vue';
import Clock from '../icons/clock.vue';

export default {
  name: 'SegmentCard',
  components: {
    MemberProfileCard,
    spinner,
    draggable,
    InviteMemberModal,
    threeDots,
    EditCourseModal,
    description,
    Clock,
  },
  props: ['segment'],
  data() {
    return {
      deleteSegmentLoader: false,
      invitePopup: false,
      removeMemberLoader: false,
      editModal: false,
      showDescription: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.userDetails;
    },
    segmentMemberLimit() {
      return this.$store?.state?.userDetails?.myAccess?.segmentMember;
    },
    pipelineMemberLimit() {
      return this.$store.state?.userDetails?.myAccess?.pipelineMemberLimit;
    },
    pipelineStudentsCount() {
      return this.$store.state.pipeline.pipelineStudentsCount;
    },
    currentPipelineDetails: {
      get() {
        return this.$store.state.pipeline.currentPipelineDetails;
      },
      set(newName) {
        return newName;
      },
    },
    isReminderDone() {
      const currentTime = new Date(Date.now()).getTime();
      const reminderTime = new Date(
        this.segment.courseInfo.userinfos?.reminder?.reminderTime,
      ).getTime();
      return reminderTime < currentTime;
    },
  },
  methods: {
    async log(evt) {
      if (evt.added) {
        try {
          console.log(evt.added.element, 'adding');
          const memberData = evt.added.element;
          if (memberData?.userName) {
            const response = await this.$store.dispatch(
              'enrollMembersToCourse',
              {
                enrolledStudents: [
                  { name: memberData.userName, ...memberData },
                ],
                segmentId: this.segment?.courseInfo?.courseId,
              },
            );
            console.log(response);
            // await this.$store.dispatch('getPipelineDetails');
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (evt.removed) {
        this.deleteConfirmed(evt.removed?.element);
      }
    },
    async handleRemoveSegment(segmentIndex) {
      this.deleteSegmentLoader = true;
      const response = await this.$store.dispatch(
        'deleteSegmentFromPipeline',
        segmentIndex,
      );
      console.log(response);
      await this.$store.dispatch('getPipelineDetails');
      this.deleteSegmentLoader = false;
    },
    invitecancel() {
      this.invitePopup = false;
      this.$store.dispatch('getPipelineDetails');
    },
    async deleteConfirmed(memberData, isReloadData = false) {
      try {
        this.removeMemberLoader = true;
        const res = await this.$store.dispatch('removeMemberFromCourse', {
          studentType: 'enrolled',
          studentId: [memberData._id],
          courseId: this.segment.courseInfo?.courseId,
          removesubmissions: true,
        });
        console.log(res);
        if (isReloadData) {
          await this.$store.dispatch('getPipelineDetails');
        }
        this.removeMemberLoader = false;
      } catch (error) {
        console.log({ error });
        this.deleteModal = false;
        this.removeMemberLoader = false;
      }
    },
  },
};
</script>

<style></style>
